import * as actions from './actions';
import reducer from './reducer';
import * as selectors from './selectors';
import * as types from './types';

export default reducer;
export { actions, selectors, types };
